// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const MetricOut = zod.object({
  "after": zod.union([zod.string(),zod.null()]),
  "before": zod.union([zod.string(),zod.null()]),
  "id": zod.uuid(),
  "label": zod.string(),
  "position": zod.int(),
  "provenance": zod.string(),
  "unit": zod.union([zod.string(),zod.null()]),
  "value": zod.union([zod.string(),zod.null()])
});

export type MetricOut = zod.input<typeof MetricOut>;
export type MetricOutOutput = zod.output<typeof MetricOut>;
